export const BLOG_PREFIX = 'blog';

export const BLOG_BLOCK_NAME = {
  BLOG_AUTHOR: 'blogAuthorBlock',
  BLOG_SUBTITLE: 'blogSubtitle',
  BLOG_POST: 'blogPost',
  BLOG_CONTENT_BLOCK: 'blogContentBlock',
};

export const BLOG_SECTION_NAME = {
  BLOG_HEADER: 'blogHeader',
  BLOG_CONTENT: 'blogContent',
  BLOG_SIMILAR_POSTS: 'blogSimilarPosts',
};

export const PAGE_SECTION_NAME = {
  PAGE_HEADER: 'pageHeader',
  PAGE_CONTENT: 'pageContent',
  PAGE_CONTENT_PHOTOS: 'pageContentPhotos',
};